enum EconsentType {
  IN_PERSON = 'IN_PERSON',
  REMOTE = 'REMOTE',
}

export default EconsentType;
